// extracted by mini-css-extract-plugin
export default {"Loading":"preloader_Loading__xJnmz","circle":"preloader_circle__ozLJG","spinner-border":"preloader_spinner-border__ttRS3","spin":"preloader_spin__T6rDR"};